var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3, _react_refresh_temp_4;
var _react_refresh_temp_5;
_react_refresh_temp_5 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, useCallback } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { createLocalScreenTracks, Track, } from 'livekit-client';
import { store, useAppDispatch, useAppSelector, } from '../../../store';
import { updateIsActiveScreenshare } from '../../../store/slices/bottomIconsActivitySlice';
import { updateScreenSharing } from '../../../store/slices/sessionSlice';
import { getScreenShareResolution } from '../../../helpers/utils';
const isActiveScreenshareSelector = createSelector(_react_refresh_temp_1 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.isActiveScreenshare);
$RefreshReg$(_react_refresh_temp_1, "isActiveScreenshareSelector$createSelector");
const sessionScreenSharingSelector = createSelector(_react_refresh_temp_2 = (state) => state.session, (session) => session.screenSharing);
$RefreshReg$(_react_refresh_temp_2, "sessionScreenSharingSelector$createSelector");
const isScreenshareLockSelector = createSelector(_react_refresh_temp_3 = (state) => { var _a, _b; return (_b = (_a = state.session.currentUser) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.lock_settings; }, (lock_settings) => lock_settings === null || lock_settings === void 0 ? void 0 : lock_settings.lock_screen_sharing);
$RefreshReg$(_react_refresh_temp_3, "isScreenshareLockSelector$createSelector");
const ScrenshareIcon = ({ currentRoom }) => {
    var _a, _b;
    _react_refresh_temp_5();
    const showTooltip = store.getState().session.userDeviceType === 'desktop';
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const isActiveScreenshare = useAppSelector(isActiveScreenshareSelector);
    const sessionScreenSharing = useAppSelector(sessionScreenSharingSelector);
    const isScreenshareLock = useAppSelector(isScreenshareLockSelector);
    const [iconCSS, setIconCSS] = useState('primaryColor');
    const [lock, setLock] = useState(false);
    const isAdmin = (_b = (_a = store.getState().session.currentUser) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.is_admin;
    useEffect(() => {
        if (sessionScreenSharing.isActive &&
            sessionScreenSharing.sharedBy === currentRoom.localParticipant.identity) {
            setIconCSS('secondaryColor');
        }
        else {
            setIconCSS('primaryColor dark:text-darkText');
        }
    }, [sessionScreenSharing]);
    const endScreenShare = useCallback(async () => {
        if (isActiveScreenshare) {
            for (const [, publication,] of currentRoom.localParticipant.tracks.entries()) {
                if ((publication.source === Track.Source.ScreenShare ||
                    publication.source === Track.Source.ScreenShareAudio) &&
                    publication.track) {
                    await currentRoom.localParticipant.unpublishTrack(publication.track, true);
                }
            }
            dispatch(updateIsActiveScreenshare(false));
            dispatch(updateScreenSharing({
                isActive: false,
                sharedBy: '',
            }));
        }
    }, [isActiveScreenshare, dispatch, currentRoom]);
    // for change in lock setting
    useEffect(() => {
        if (isAdmin) {
            return;
        }
        if (isScreenshareLock) {
            setLock(true);
            endScreenShare();
        }
        else if (!isScreenshareLock) {
            setLock(false);
        }
    }, [endScreenShare, isScreenshareLock]);
    // for special case when user will cancel sharing from browser directly
    // we will check & disable button status.
    useEffect(() => {
        if (!sessionScreenSharing.isActive && isActiveScreenshare) {
            dispatch(updateIsActiveScreenshare(false));
        }
    }, [sessionScreenSharing]);
    const toggleScreenShare = async () => {
        try {
            if (lock) {
                return;
            }
            if (!isActiveScreenshare) {
                if (sessionScreenSharing.isActive) {
                    toast(t('footer.notice.already-active-screen-sharing'), {
                        toastId: 'dup-screen-share',
                        type: 'warning',
                    });
                    return;
                }
                const option = {
                    audio: true,
                };
                // because of one bug we'll disable to set regulation for safari
                // https://bugs.webkit.org/show_bug.cgi?id=263015
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                if (!isSafari) {
                    option.resolution = getScreenShareResolution();
                }
                const localTracks = await createLocalScreenTracks(option);
                for (let i = 0; i < localTracks.length; i++) {
                    const track = localTracks[i];
                    await currentRoom.localParticipant.publishTrack(track);
                }
                dispatch(updateIsActiveScreenshare(true));
                dispatch(updateScreenSharing({
                    isActive: true,
                    sharedBy: currentRoom.localParticipant.identity,
                }));
            }
            else {
                endScreenShare();
            }
        }
        catch (error) {
            console.log(error);
            endScreenShare();
        }
    };
    const text = () => {
        if (isActiveScreenshare) {
            return t('footer.icons.stop-screen-sharing');
        }
        else if (!isActiveScreenshare && !lock) {
            return t('footer.icons.start-screen-sharing');
        }
        else if (lock) {
            return t('footer.icons.screen-sharing-locked');
        }
    };
    const shouldShow = () => {
        var _a;
        const session = store.getState().session;
        const metadata = session.currentRoom.metadata;
        return (_a = metadata.room_features) === null || _a === void 0 ? void 0 : _a.allow_screen_share;
    };
    const render = () => {
        return (_jsxs("div", { className: `share-screen footer-icon h-[35px] lg:h-[40px] w-[35px] lg:w-[40px] relative rounded-full bg-[#F2F2F2] dark:bg-darkSecondary2 hover:bg-[#ECF4FF] ltr:mr-3 lg:ltr:mr-6 rtl:ml-3 lg:rtl:ml-6 hidden md:flex items-center justify-center cursor-pointer ${showTooltip ? 'has-tooltip' : ''}`, onClick: () => toggleScreenShare(), children: [_jsx("span", { className: "tooltip", children: text() }), _jsxs(_Fragment, { children: [_jsx("i", { className: `pnm-screen-share ${iconCSS} text-[14px] lg:text-[16px]` }), lock ? (_jsx("div", { className: "arrow-down absolute -bottom-1 -right-1 w-[16px] h-[16px] rounded-full bg-white flex items-center justify-center", children: _jsx("i", { className: "pnm-lock primaryColor" }) })) : null] })] }));
    };
    return _jsx(_Fragment, { children: shouldShow() ? render() : null });
};
_react_refresh_temp_4 = ScrenshareIcon;
$RefreshReg$(_react_refresh_temp_4, "ScrenshareIcon");
_react_refresh_temp_5(ScrenshareIcon, "HtmqdOGrntqqo1Zu7+u3AcPVqLw=", false, () => [useAppDispatch, useTranslation, useAppSelector, useAppSelector, useAppSelector]);
export default ScrenshareIcon;
